import BookPanda from "../../assets/images/Panda/red-panda-computer.png";
import ResponsiveImage from "../common/ResponsiveImage";

const SectionBannerKnowledge = () => {
  return (
    <div className="">
      <div className="flex justify-center items-center h-[500px] px-10 container">
        <div className="w-1/2 text-left">
          <div className="text-4xl font-bold color-second">
            Kiến thức Website
          </div>
          <div className="text-3xl font-bold color-second mt-6">
            Chia sẻ - Học hỏi - Phát triển
          </div>
          <div className="text-lg mt-6 color-grey leading-8">
            Khám phá những kiến thức hữu ích về thiết kế website, <b>SEO</b>, 
            phát triển web và các xu hướng công nghệ mới nhất. 
            Nâng cao kỹ năng và hiểu biết của bạn cùng TrioCore Solutions.
          </div>
          <div className="mt-6 gap-4 flex">
            <button className="button-secondary">Xem bài viết mới</button>
            <button className="button-primary">Đăng ký nhận tin</button>
          </div>
        </div>
        <div className="w-1/2 offset-lg-0 col-md-12 no-padding-left mt-20">
          <div className="welcome-meter">
            <div className="relative h-[500px]">
               <ResponsiveImage className="gt-transparency-anim-bg" src={BookPanda} alt="Knowledge Panda" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionBannerKnowledge;

